import React, { useState } from 'react';
import { useGame } from '../context/GameContext';

export const PatientForm: React.FC = () => {
  const { dispatch } = useGame();
  const [formData, setFormData] = useState({
    patientId: '',
    ageRange: '',
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const sessionId = `${formData.patientId}-${Date.now()}`;
    dispatch({
      type: 'START_SESSION',
      payload: {
        patientId: formData.patientId,
        sessionId,
        ageRange: formData.ageRange,
      },
    });
  };

  return (
    <form onSubmit={handleSubmit} className="max-w-md mx-auto space-y-6 p-6 bg-white rounded-lg shadow-md">
      <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">Patient Information</h2>
      
      <div className="space-y-4">
        <div>
          <label htmlFor="patientId" className="block text-sm font-medium text-gray-700 mb-1">
            Patient ID
          </label>
          <input
            type="text"
            id="patientId"
            required
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={formData.patientId}
            onChange={(e) => setFormData(prev => ({ ...prev, patientId: e.target.value }))}
            aria-label="Patient ID"
          />
        </div>

        <div>
          <label htmlFor="ageRange" className="block text-sm font-medium text-gray-700 mb-1">
            Age Range
          </label>
          <select
            id="ageRange"
            required
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={formData.ageRange}
            onChange={(e) => setFormData(prev => ({ ...prev, ageRange: e.target.value }))}
            aria-label="Age Range"
          >
            <option value="">Select age range</option>
            <option value="0-12">0-12 years</option>
            <option value="13-17">13-17 years</option>
            <option value="18-30">18-30 years</option>
            <option value="31-50">31-50 years</option>
            <option value="51-70">51-70 years</option>
            <option value="71+">71+ years</option>
          </select>
        </div>
      </div>

      <button
        type="submit"
        className="w-full py-2 px-4 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
        aria-label="Start Session"
      >
        Start Session
      </button>
    </form>
  );
};